// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__KG3kv","spacer":"loading-dots_spacer__9CecC","blink":"loading-dots_blink__G02So"};